import { PrivateVideo } from '../../../private/services/video/video';
import { PublicCatalogService } from '../../../catalog-services/public-catalog-service';
/**
 * Public service for working with Video entity
 * @doc PublicVideo
 */
export class PublicVideo extends PublicCatalogService {
    constructor(httpClient, baseUrl) {
        super(httpClient, baseUrl);
        this.privateVideo = new PrivateVideo(httpClient, baseUrl);
    }
    /**
     * Get download link for video
     * @param {string} baseUrl
     * @param {string} videoId
     * @param {string} channelId
     * @param {string} instance
     * @example
     *
     * const {videoId, channelId} = this.props;
     * const instance = Wix.Utils.getInstance();
     *
     * return (
     *   <div>
     *     Your download url is: {PublicVideo.getDownloadUrl(videoId, channelId, instance)}
     *   </div>
     * );
     */
    static getDownloadUrl(baseUrl, videoId, channelId, instance) {
        return `${baseUrl}/public/download/${videoId}/redirect?instance=${instance}&channel_id=${channelId}`;
    }
    /**
     * Fetch video entity by videoId
     * @param {string} videoId
     * @param {RequestOptions} requestConfig
     * @example
     *
     * const video = await new PublicVideo()
     *  .getById('here-could-have-been-your-video-id')
     *  .then(response => response.data)
     */
    getById(videoId, requestConfig) {
        return this.privateVideo.getById(videoId, requestConfig);
    }
    /**
     * Get urls to video files for given videoId.
     * @param {string} videoId
     * @param {string} channelId
     * @param {string} instance
     * @param {RequestOptions} requestConfig
     * @example
     *
     * const videoUrls = await new PublicVideo()
     *  .getVideoUrls('video-id')
     *  .then(response => response.data);
     */
    getVideoUrls(videoId, channelId, instance, requestConfig) {
        return this.get(`/public/play/${videoId}`, {
            params: {
                instance,
                channel_id: channelId,
            },
            ...requestConfig,
        });
    }
}
//# sourceMappingURL=video.js.map